import { client } from "api";
import { Creator } from "models/Checklist";

export type GetExternalInstallersResponse = Creator[];

export const getExternalInstallers = (): Promise<GetExternalInstallersResponse> =>
  client.get<GetExternalInstallersResponse>(`/user/getExternalInstallers`).then((res) => res.data);
